<template>
  <div class="goodsType">
    <div class="chart" ref="chart"/>
  </div>
</template>

<script>
import echarts from "echarts";
import api from '../api/index'

export default {
  name: "GoodsType",
  data() {
    return {
      chart: null
    }
  },
  mounted() {
    this.queryInfo()
  },
  methods: {
    async queryInfo() {
      const {success, returnObj} = await this.$fetch(api.dispatch.queryGoods)
      if (success) {
        const arr = returnObj ? returnObj : []
        this.initCharts(arr)
      }
    },
    initCharts(arr) {
      if (this.chart) {
        this.chart.dispose()
        this.chart = null
      }
      const xData = ["冷藏品", "木材", "重大件"];
      const yData = [20, 50, 30];
      const option = {
        grid: {
          bottom: 10,
          containLabel: true,
          left: 25,
          right: 10,
        },
        tooltip: {
          show: true,
        },
        xAxis: [
          {
            type: "category",
            data: arr.map(v => v.goodsName),
            axisTick: {
              show: false,
            },
            axisLabel: {
              color: "rgba(255,255,255,0.7)",
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#1B7EF2",
              }
            }
          }
        ],
        yAxis: [
          {
            show: true,
            type: "value",
            axisLabel: {
              textStyle: {
                color: "#fff",
              },
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: "rgba(230,247,255,0.2)",
              },
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              show: false,
              lineStyle: {
                color: "#2D3C5C",
              },
            },
          },
        ],
        series: [
          {
            name: "",
            type: "pictorialBar",
            symbolSize: [16, 4],
            symbolOffset: [0, -2], // 上部椭圆
            symbolPosition: "end",
            z: 12,
            // "barWidth": "0",
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                  {
                    offset: 0,
                    color: "#43D1FF",
                  }, {
                    offset: 1,
                    color: "#2EE294",
                  }
                ])
              }
            },
            data: arr.map(v => v.goodsTotal),
          },
          {
            type: "bar",
            barWidth: "16px",
            itemStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(1, 0, 0, 0, [
                  {
                    offset: 0,
                    color: "rgba(2,206,214,0.8)",
                  }, {
                    offset: 0.5,
                    color: "rgba(44,162,163,0.5059)",
                  }, {
                    offset: 1,
                    color: "rgba(25,217,170,0.8)",
                  }
                ])
              }
            },
            data: arr.map(v => v.goodsTotal),
          },
        ],
      };

      this.chart = echarts.init(this.$refs.chart);
      this.chart.setOption(option);
    }
  }
}
</script>

<style lang="scss" scoped>
.goodsType {
  height: 100%;
  width: 100%;

  .chart {
    height: 100%;
    width: 100%;
  }
}
</style>
